import React, { FC, PropsWithChildren } from 'react'
import { makeStyles } from 'tss-react/mui'
import { IconButton, useTheme } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'
import { BrandColorType } from '@dg-shared/typography/Typography'

const useStyles = makeStyles()(() => ({
  iconQuestion: {
    display: 'flex',
    justifyContent: 'flex-start',
  },

  iconButtonQuestion: {
    padding: 0,
    paddingLeft: '5px',
  },
}))

interface DetailedInfoButtonShared {
  showDetails: () => void
  color?: BrandColorType
}

const DetailedInfoButtonShared: FC<PropsWithChildren<DetailedInfoButtonShared>> = ({
  color = 'textSecondary',
  showDetails,
  children,
}) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const brandColor = theme.brand.colors[color]

  return (
    <section className={classes.iconQuestion}>
      {children}
      {/* //TODO: Translate aria-label */}
      <IconButton
        aria-label='click to know why'
        className={classes.iconButtonQuestion}
        onClick={showDetails}
        size='large'
      >
        <InfoOutlined htmlColor={brandColor} fontSize='small' />
      </IconButton>
    </section>
  )
}

export default DetailedInfoButtonShared
